import React from 'react';
import { Button, Header } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { Course } from '../../interfaces/interfaces'; // Adjust import based on your structure

interface CoursesListProps {
    courses: Course[];
    onReviewClick: () => void;
    professorName: string;
}

const CoursesList: React.FC<CoursesListProps> = ({
    courses,
    onReviewClick,
    professorName,
}) => {
    return (
        <>
            <Header as="h2" content="Courses" />
            {courses.map((course) => (
                <p key={course.course_id} className="no-margin-bottom">
                    <Link to={`/course/${course.course_id}`}>
                        [{course.course_code}] {course.course_name}
                    </Link>
                </p>
            ))}
            <br />
            <Button className="orange-button" onClick={onReviewClick}>
                {`WRITE A REVIEW FOR ${professorName.toUpperCase()}`}
            </Button>
        </>
    );
};

export default CoursesList;
